<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-card>
        <v-card-text>
          <v-row class="justify-center">
            <v-col
              cols="12"
              lg="12"
            >
              <v-form ref="form_all">
                <v-row class="justify-center">
                  <v-col
                    cols="12"
                    lg="12"
                  >
                    <v-text-field
                      v-model="form.password"
                      label="Текущий пароль"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    lg="12"
                  >
                    <v-text-field
                      v-model="form.newpassword"
                      label="Новый пароль"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    lg="12"
                  >
                    <v-text-field
                      v-model="form.renewpassword"
                      label="Повторите новый пароль"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row class="justify-center">
            <v-col
              cols="6"
              lg="3"
            >
              <v-btn
                color="primary"
                outlined
                @click="$router.go(-1)"
              >
                <span class="mx-3">Назад</span>
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              lg="3"
              class="text-right"
            >
              <v-btn
                color="primary"
                class="ml-auto"
                @click="change_password"
              >
                <span class="mx-3">Сохранить</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  import $ from 'jquery'
  export default {
    data: () => ({
      form: {
        password: '',
        newpassword: '',
        renewpassword: ''
      },
    }),
    computed: {
    },
    watch: {
    },
    mounted: function () {
    },
    methods: {
      change_password: function () {
        if (this.form.newpassword === this.form.renewpassword) {
          const item = JSON.parse(JSON.stringify(this.$store.state.user))
          item.password = this.form.password
          item.newpassword = this.form.newpassword
          this.axios.post('/api/user/save', item)
            .then(result => {
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Данные успешно сохранены')
              } else {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })
        }
      },
    },
  }
</script>
